/* A native button supplies Enter/Space support; switch semantics announce the state. */
if (!customElements.get('ks-color-mode')) {
  customElements.define('ks-color-mode', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const button = this.querySelector('button');
      if (!button || !window.KSColorMode) return;
      const sync = () => {
        const dark = window.KSColorMode.get() === 'dark';
        button.setAttribute('aria-checked', String(dark));
        button.title = dark ? button.dataset.lightLabel : button.dataset.darkLabel;
      };
      button.addEventListener('click', () => {
        window.KSColorMode.set(window.KSColorMode.get() === 'dark' ? 'light' : 'dark');
      }, { signal: this.abort.signal });
      document.addEventListener('ks:color-mode', sync, { signal: this.abort.signal });
      sync();
      this.dataset.ready = '';
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
